// Entry point for the build script in your package.json
//
// Bundle unique (Rails omakase, INTRA-APP) :
//   • mountRoom     → monte le composant salle sur #livekit-room quand présent
//                     (stage/viewer/join en état live) ;
//   • mountCountdown → active [data-countdown] sur la page avant-direct ;
//   • mountLiveStateControl → « Reprendre le direct » sur la scène d'un
//                     direct terminé ([data-live-state-control]) ;
//   • mountCopyLinks → boutons « Copier le lien » de la page animateur
//                     ([data-copy-link]) ;
//   • mountRegie    → régie du direct, onglet animateur sans vidéo (#regie),
//                     qui monte aussi les consoles Sondages et Questions.
// Chaque fonction est un no-op si son marqueur DOM est absent — les pages
// qui ne portent qu'un des marqueurs (catalogue, avant-direct, salle)
// consomment le même bundle sans effet croisé.

import { mountRoom } from "./rooms/room.jsx";
import { mountCountdown } from "./countdown.js";
import { mountLiveStateControl } from "./rooms/live_state_control.jsx";
import { mountCopyLinks } from "./copy_link.js";
import { mountRegie } from "./rooms/regie.jsx";

const boot = () => {
  mountRoom();
  mountCountdown();
  mountLiveStateControl();
  mountCopyLinks();
  mountRegie();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
